var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 182,
    height: 51,
    viewBox: "0 0 182 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5938 40.4961V0H33.3047V40.4961H25.5938Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7891 25.9492C37.7891 23.0326 38.4727 20.3893 39.8398 18.0195C41.2253 15.6497 43.1211 13.7995 45.5273 12.4688C47.9336 11.138 50.6042 10.4727 53.5391 10.4727C56.4922 10.4727 59.1719 11.1471 61.5781 12.4961C63.9844 13.8268 65.8711 15.6771 67.2383 18.0469C68.6237 20.3984 69.3164 23.0326 69.3164 25.9492C69.3164 30.3789 67.8307 34.0339 64.8594 36.9141C61.9062 39.7943 58.1328 41.2344 53.5391 41.2344C48.9818 41.2344 45.2174 39.7943 42.2461 36.9141C39.2747 34.0339 37.7891 30.3789 37.7891 25.9492ZM45.5273 25.9492C45.5273 28.4284 46.2839 30.4609 47.7969 32.0469C49.3099 33.6146 51.224 34.3984 53.5391 34.3984C55.8724 34.3984 57.7956 33.6146 59.3086 32.0469C60.8398 30.4609 61.6055 28.4284 61.6055 25.9492C61.6055 23.4518 60.8398 21.3919 59.3086 19.7695C57.7773 18.1289 55.8542 17.3086 53.5391 17.3086C51.2057 17.3086 49.2826 18.1198 47.7695 19.7422C46.2747 21.3646 45.5273 23.4336 45.5273 25.9492Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M71.1211 11.2109H79.543L84.6836 31.9922L90.2891 11.2109H97.5625L103.113 31.9922L108.309 11.2109H116.703L107.926 40.4961H99.2852L93.9258 21.7383L88.4844 40.4961H79.8711L71.1211 11.2109Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M119.438 17.4727V11.2109H122.555V5.05859H130.184V11.2109H135.652V17.4727H130.184V28.793C130.184 30.8893 130.503 32.293 131.141 33.0039C131.797 33.6966 132.909 34.043 134.477 34.043C135.005 34.043 135.479 34.0247 135.898 33.9883V40.6055C135.115 40.7878 134.012 40.8789 132.59 40.8789C129.126 40.8789 126.574 39.9036 124.934 37.9531C123.311 36.0026 122.5 33.0221 122.5 29.0117V17.4727H119.438Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M140.492 40.4961V0H148.203V40.4961H140.492Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M173.086 11.2109L166.469 30.2969L162.887 39.7578L158.785 50.5312H166.195L181.152 11.2109H173.086Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M159.906 11.2109H151.621L162.887 39.7578L166.469 30.2969L159.906 11.2109Z",
    fill: "#715DFA"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0 40.4961H7.90234V8.39453H0V40.4961Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5391 24.6914L18.5391 17.6367H7.90234V24.6914H16.5391Z",
    fill: "#715DFA"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M20.043 1.28516H0V8.39453H18.043L20.043 1.28516Z",
    fill: "#715DFA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.0d3653c3d98f779b875cb80d3f490950.svg";
export { ForwardRef as ReactComponent };